import React, { useState } from "react";
import { SectionFragment } from '../../../graphql/generated/definitions';
import { ChevronDownIcon } from "../../icons";

import {
  H3,
} from "../../wombat-ui";

type SectionProps = {
  section: SectionFragment;
  children: React.ReactNode[] | React.ReactNode;
  displayedIndex?: string;
  defaultOpen?: boolean;
};

const Section: React.FC<SectionProps> = ({
  section,
  children,
  displayedIndex,
  defaultOpen = false
}) => {
  const [sectionOpen, setSectionOpen] = useState(defaultOpen);

  return (
    <div className={`px-4 py-3 bg-white rounded shadow`}>
      <div
        className="flex justify-between align-middle"
        role="button"
        id={`sectionOpenTrigger-${section.id}`}
        onClick={() => setSectionOpen(!sectionOpen)}
      >
        <div className="flex flex-col justify-center">
          <H3
            description={section.description}
            className="text-primary-700 text-align-center"
          >
            {
              displayedIndex ? `${displayedIndex}. ${section.title}` : section.title
            }
          </H3>
        </div>
        <div className="flex flex-col justify-center print:hidden">
          <ChevronDownIcon className="w-6 h-6 text-dark-100" />
        </div>
      </div>
      <div
        id={`section-${section.id}`}
        className={`transform space-y-10 transition-all ${
          sectionOpen ? "pt-8 opacity-100" : "opacity-0 hidden h-0 print:block print:opacity-100 print:h-auto"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default React.memo(Section);
